import { AccessRight } from '../enums/access.right.enum';
import { QuestionType } from '../enums/question.type.enum';

export class QuestionGroup {
    id: string;
    name: string;
    accessRight: AccessRight;
    questionType: QuestionType;
    maxAnswers: number;
   constructor() {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/question.group.model.ts